"use client";

import PropTypes from "prop-types";
import styled from "styled-components";
import { textColorPrimary, textColorSecondary, textColorTertiary } from "@churchofjesuschrist/eden-style-constants";
import { Text4 } from "@churchofjesuschrist/eden-text";
import { jsx as _jsx } from "react/jsx-runtime";
export const InternalUseOnlyLabel = styled(Text4).withConfig({
  componentId: "sc-8e6q3s-0"
})(["color:", ";&:has(input[type=\"checkbox\"],input[type=\"radio\"]){color:", ";}&:has(input[type=\"checkbox\"]:disabled,input[type=\"radio\"]:disabled){color:", ";cursor:not-allowed;}"], textColorSecondary, textColorPrimary, textColorTertiary);

/**
 * The Label represents a caption for an item in a user interface.
 */
const Label = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(InternalUseOnlyLabel, {
    renderAs: "label",
    ...props,
    children: children
  });
};
Label.displayName = "Label";
Label.propTypes = {
  /** Indicates the id of the form element that the label describes */
  htmlFor: PropTypes.string,
  /** Content to render inside the Label Component */
  children: PropTypes.node.isRequired
};
export default Label;